import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { EbwModalService } from '@ebw-monorepo/modal';
import { SplitViewService } from '@ebw-monorepo/utils';
import { SplitViewConf } from 'libs/ng-components/utils/src/lib/models/split-view-conf';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { IMapTable } from '../../../interfaces/mapTable.interface';
import { API_URLS, ApiUrlService } from '../../../../../../utils/src/lib/services/api-url.service';
import { MapTableService } from '../../../services/map-table.service';
import { TelcoService } from '../../../services/telco.service';
import { MapTableComponent } from '../../map-table/map-table.component';

@Component({
  selector: 'ebw-monorepo-analisi-schiacciamenti',
  templateUrl: './analisi-schiacciamenti.component.html',
  styleUrls: ['./analisi-schiacciamenti.component.scss']
})
export class AnalisiSchiacciamentiComponent implements OnInit {
  form: FormGroup;
  public searchResultsCampo1: any[] = []; //TODO: cambiare tipizzazione appena si conosce la risposta solr
  public searchResultsCampo2: any[] = []; //TODO: cambiare tipizzazione appena si conosce la risposta solr
  public searchResultsCampo3: any[] = []; //TODO: cambiare tipizzazione appena si conosce la risposta solr
  public searchResultsCampo4: any[] = []; //TODO: cambiare tipizzazione appena si conosce la risposta solr
  public autocompleted: boolean = false;

  _contextId = 'schiacciamenti_table';
  // ------------------------------------------------------------------------------------------------

  constructor(
    private _fb: FormBuilder,
    private _mapTableService: MapTableService,
    private _telcoService: TelcoService,
    private ebwModalService: EbwModalService,
    private i18NService: I18NService,
    private _splitViewService: SplitViewService,
    private _apiUrlService: ApiUrlService
  ) {}

  // ------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this._initForm();
  }

  // ------------------------------------------------------------------------------------------------

  private _initForm() {
    this.form = this._fb.group({
      segmento1: ['', [Validators.required, this.checkIfOptionSelectedSegmento1.bind(this)]],
      segmento2: ['', [Validators.required, this.checkIfOptionSelectedSegmento2.bind(this)]],
      segmento3: [''],
      segmento4: ['']
    });

    this._setupAutocomplete('segmento1', 'searchResultsCampo1');
    this._setupAutocomplete('segmento2', 'searchResultsCampo2');
    this._setupAutocomplete('segmento3', 'searchResultsCampo3');
    this._setupAutocomplete('segmento4', 'searchResultsCampo4');
  }

  // ------------------------------------------------------------------------------------------------

  checkIfOptionSelectedSegmento1(control: any) {
    try {
      const segmentoInvalid = !this.searchResultsCampo1.find((obj) => obj.desc === control.value);
      return segmentoInvalid ? { optionError: true } : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  // ------------------------------------------------------------------------------------------------

  checkIfOptionSelectedSegmento2(control: any) {
    try {
      const segmentoInvalid = !this.searchResultsCampo2.find((obj) => obj.desc === control.value);
      return segmentoInvalid ? { optionError: true } : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  // ------------------------------------------------------------------------------------------------

  private _setupAutocomplete(controlName: string, resultsArrayName: string) {
    // mi sottoscrivo ai cambiamenti dell'autocomplete per avviare la ricerca su solr
    this.form
      .get(controlName)
      .valueChanges.pipe(
        // tempo minimo tra una richiesta e l'altra
        debounceTime(300),
        filter((value: string) => {
          if (this.autocompleted) {
            this.autocompleted = false;
            return false;
          }

          return true;
        }),
        // cerco solo con almeno 3 caratteri
        filter((value: string) => value.length > 2),
        // solo se il testo cambia
        distinctUntilChanged(),
        // ricarca solr
        switchMap((value: string) => this._telcoService.analisiSchiacciamentiSearch(value))
      )
      .subscribe({
        next: (results: any[]) => {
          this.autocompleted = false;
          // pulisco eventuali errori rimasti
          // this.form.get(controlName).setErrors(null);
          // Se non ho trovato risultati
          if (!results.length) {
            this[resultsArrayName] = [];
            return;
          }
          // altrimenti popolo le opzioni dell'autocomplete
          this[resultsArrayName] = results;
        },
        error: (error) => {
          // setto eventuali errori e pulisco l'array
          console.error('[AnalisiSchiacciamenti][SolrSearch]', error);
          this[resultsArrayName] = [];
          this.form.get(controlName).setErrors({ solrError: true });
          // mi risottoscrivo altrimenti le ricerche successive non funzionano
          this._setupAutocomplete(controlName, resultsArrayName);
        }
      });
  }

  // ------------------------------------------------------------------------------------------------

  submitForm() {
    if (this.form.invalid) {
      return;
    }
    const { segmento1, segmento2, segmento3, segmento4 } = this.form.value;
    const urn1: string = this.searchResultsCampo1.find((obj) => obj.desc === segmento1)?.urns;
    const urn2: string = this.searchResultsCampo2.find((obj) => obj.desc === segmento2)?.urns;
    const urn3: string = this.searchResultsCampo3.find((obj) => obj.desc === segmento3)?.urns;
    const urn4: string = this.searchResultsCampo4.find((obj) => obj.desc === segmento4)?.urns;
    // faccio questo controllo perchè l'utente deve aver selezionato un opzione valida in ogni campo del form
    if (!urn1 || !urn2) {
      const content = this.i18NService.getTranslateParameter('map.sidebar.analisi_schiacciamenti.invalid_error_option');
      const title = this.i18NService.getTranslateParameter('common.warning');
      this.ebwModalService.openWarningModal({ title, content });
      return;
    }
    let urns = urn1.concat(',').concat(urn2);
    // se sono popolati aggiungo anche urn3 e urn4
    !!urn3 && (urns += `,${urn3}`);
    !!urn4 && (urns += `,${urn4}`);
    this.startAnalisiSchiacciamenti(urns);
  }

  // ------------------------------------------------------------------------------------------------

  private startAnalisiSchiacciamenti(urns: string) {
    const url = this._apiUrlService.createUrl(API_URLS.MAP.TELCO.SCHIACCIAMENTO) + '?items=' + urns;

    const config: IMapTable = {
      id: null,
      url,
      title: 'map.sidebar.analisi_schiacciamenti.title',
      pagination: false,
      showLevels: false,
      method: 'GET',
      marker: 'place'
    };

    const splitViewConf: SplitViewConf = {
      title: config.title,
      icon: 'table_view'
    };
    this._splitViewService.show(MapTableComponent, this._contextId, null, splitViewConf);
    this._mapTableService.setMapTableConfig(config);
  }

  public onItemSelect(value, control): void {
    this.autocompleted = true;
    this.form.get(control)?.setValue(value);
  }
}
